import { render } from "./PerformanceEvaluationAdministration.vue?vue&type=template&id=d836165a&scoped=true&lang=html"
import script from "./PerformanceEvaluationAdministration.vue?vue&type=script&lang=js"
export * from "./PerformanceEvaluationAdministration.vue?vue&type=script&lang=js"

import "./PerformanceEvaluationAdministration.vue?vue&type=style&index=0&id=d836165a&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-d836165a"

export default script